export default "__VITE_ASSET__CigNtHNs__"